import httpClient from './httpClient';

export const fetchAssessments = async (studentId) => {
  const { data } = await httpClient.get(`/assessments/${studentId}`);
  return data;
};

export const createAssessment = async (payload) => {
  const { data } = await httpClient.post('/assessments', payload);
  return data;
};

export const updateAssessment = async (id, payload) => {
  const { data } = await httpClient.put(`/assessments/${id}`, payload);
  return data;
};

export const deleteAssessment = async (id) => {
  await httpClient.delete(`/assessments/${id}`);
};
